import React, { useEffect } from 'react';

/**
 * The marketing landing page lives as a self-contained static file at
 * /landing.html (see frontend/public/landing.html). Vercel rewrites the
 * root path to that file in production. This component handles the
 * SPA-internal case (e.g. clicking a <Link to="/">) by forcing a full
 * page reload to the static HTML so users always see the same landing
 * regardless of how they got there.
 */
const LandingPage: React.FC = () => {
  useEffect(() => {
    window.location.replace('/landing.html');
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#000',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, sans-serif',
        fontSize: 14,
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        opacity: 0.6,
      }}
    >
      Yükleniyor…
    </div>
  );
};

export default LandingPage;
